import { Http } from "../Http";
import { AxiosPromise } from "axios";

export class LoginService {
	public static loginGetDetail(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Auth/login', obj, { headers: { 'Content-Type': 'application/json' } })
			.then(response => {
				return response;
			}).catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static forgotPasswordRequest(userName: string) {
		let rest = { email: userName };
		var obj = JSON.stringify(rest);
		return Http.axios().post('/api/Auth/forgot-password?UserName=' + userName, { headers: { 'Content-Type': 'application/json' } })
			.then(response => {
				return response;
			}).catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static forgotPasswordCheckToken(token: string) {
		var obj = JSON.stringify("");
		return Http.axios().post('/api/Auth/authenticate-forgot-password?Token=' + token, { headers: { 'Content-Type': 'application/json' } })
			.then(response => {
				return response;
			})
			.catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static forgotPasswordReset(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Auth/reset-password', obj, { headers: { 'Content-Type': 'application/json' } })
			.then(response => {
				return response;
			}).catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static logoutGetDetail(): AxiosPromise<any> {
		return Promise.resolve({
            success: true,
            message: "Logout successful"
        }) as unknown as AxiosPromise<any>;
	}

	public static frontAppCheckToken(token: string) {
		return Http.axios().get('/Account/checkIsValidFrontToken?token=' + token)
			.catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static getUserByRefreshToken(token: string) {
		var obj = JSON.stringify({ refreshToken: token });
		return Http.axios().post('/api/Auth/getuserbyrefreshtoken', obj, { headers: { 'Content-Type': 'application/json' } })
			.then(response => {
				return response;
			}).catch((e) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}